export const pricingsWithEnabledNotifications = [
    'Classic',
    'Pricing2015',
    'Pricing2016',
    'Pricing2017Tier1',
    'Pricing2017Tier2',
    'Pricing2018PayPerEmailPro',
    'Pricing2018UnlimitedPro',
    'Pricing2020PayPerEmailPro',
    'Pricing2020UnlimitedPro',
    'Pricing2021PayPerEmailPro',
    'Pricing2021UnlimitedPro',
];
